const SHOWCASE_EN = {
  title: 'Showcase',
  subtitle:
    'This page enables you to compare the features of each of the presented profiles. A further mean to help you choose the right one(s).',
  mobileView:
    'We have optimised this experience on Desktop, to make the data and candidate evaluations more accessible.',
  lastViewUpdate:
    'View saved on {{ date, datetime(format: MM/dd/yyyy) }} at {{ date, datetime(format: hh:mm a) }}',
  yes: 'Yes',
  no: 'No',
  bubbleText:
    'This page enables you to compare the features of each of the presented profiles. A further mean to help you choose the right one(s).',
  emptyCandidateList:
    'From here, you will be able to <strong>compare</strong> the main characteristics of the <strong>candidates</strong> we have presented to you.',
  tableRows: {
    photo: 'Photo',
    age: 'Age',
    seniority: 'Seniority',
    location: 'Location',
    must_have: 'Must have',
    nice_to_have: 'Nice to have',
    current_global_compensation: 'Current compensation package',
    desired_global_compensation: 'Desired compensation package',
    non_compete_agreement: 'Non-compete agreements',
    notice_period: 'Notice period',
    company: 'Company',
    other_selections: 'Other<1></1>selection<1></1>processes',
    motivation: 'Motivation',
    summary: 'Summary',
  },
  filters: {
    restoreView: 'Restore view',
    interestedBut: 'Show <1>Interested but</1>',
    out: 'Show <1>Out candidates</1>',
  },
  benefitsCategories: {
    car: 'Company car',
    food: 'Meal vouchers or canteen',
    training: 'Training',
    welfare: 'Welfare',
    insurance: 'Insurance',
    devices: 'Devices',
    remote_working: 'Remote work or flexible hours',
  },
  company: {
    freelance: 'Freelancer',
  },
  concernsCategories: {
    brand: 'Brand',
    role: 'Role',
    compensation: 'Salary',
    location: 'Location',
  },
  location: {
    locationAndDistance: '<strong>{{ location }}</strong>',
    locationAndDistance_withDistance:
      '<strong>{{ location }}</strong> ({{ distance }}km)',
  },
  summary: {
    readmore: 'Read more',
    hide: 'Hide',
  },
  chip: {
    interestedBut: 'Interested but',
    out: 'Out',
  },
  motivationToChangeValues: {
    low: 'Low',
    high: 'High',
    medium: 'Medium',
  },
  drivingTime: {
    hours: '<b>{{ hours }}</b> h',
    minutes: '<b>{{ minutes }}</b> min',
  },
  otherSelections: {
    inProgress: '{{ count }} in progress',
    notSpecified: 'Others in progress, not specified',
  },
  currentGlobalCompensation: {
    payTransparencyDisclaimer:
      'Asking for current or past compensation details is legally restricted as of July 7, 2026 (Directive (EU) 2023/970).<br/><br/>Focus on their desired compensation package instead.',
  },
};

export default SHOWCASE_EN;
